import { sorterByStartDate } from "../../helpers/sorting.helpers";
import type { ColumnSchema } from '../../types/column.types';
import type { IGroup } from '../../types/group.types';
import { formatGroup } from '../applicants/applicant.renderer';
import {
  AvatarGroupColumn,
  CourseFormatColumn,
  DeletePlanningGroupColumn,
  DetailGroupColumn,
  EditGroupColumn,
  GroupDescriptionColumn,
  LaunchGroupColumn,
  LessonGroupColumn,
  StartDateGroupColumn,
  TutorGroupColumn,
} from './group.renderer';

export const defaultPlanningGroupColumns: ColumnSchema<IGroup> = {
  uuid: 'defaultPlanningGroupColumns',
  schema: {
    projectCoordinator: {
      dataIndex: 'projectCoordinator',
      title: 'Project Coordinator',
      render: (_, group, idx) => AvatarGroupColumn!(null, group, idx),
      width: 200,
    },
    size: {
      title: 'size',
      dataIndex: 'size',
      render: (_, group) => group.size || 'N/A',
    },
    id: {
      title: 'Group',
      dataIndex: 'number',
      render: (_, group) => formatGroup(group),
    },
    courseFormat: {
      title: 'Course Format',
      dataIndex: 'courseFormat',
      render: CourseFormatColumn,
    },
    tutor: {
      title: 'Tutors',
      dataIndex: 'tutor',
      render: TutorGroupColumn,
    },
    startDate: {
      title: 'Start',
      dataIndex: 'startDate',
      width: 200,
      render: StartDateGroupColumn,
      sorter: sorterByStartDate,
    },
    description: {
      title: 'Description',
      dataIndex: 'description',
      render: GroupDescriptionColumn,
    },
    lesson: {
      title: 'Schedule',
      dataIndex: 'Lesson',
      width: 160,
      render: LessonGroupColumn,
    },
    launch: {
      title: 'Launch',
      dataIndex: 'id',
      align: 'center',
      width: 30,
      render: LaunchGroupColumn,
    },
    edit: {
      title: 'Edit',
      dataIndex: 'id',
      align: 'center',
      width: 30,
      render: EditGroupColumn,
    },
    delete: {
      dataIndex: 'delete',
      title: 'Delete',
      width: 30,
      render: DeletePlanningGroupColumn,
    },
    details: {
      title: 'Details',
      dataIndex: 'id',
      align: 'center',
      width: 30,
      render: (_, group) => DetailGroupColumn(_, group),
    },
  },
};
